import { Component, HostBinding } from '@angular/core';

@Component({
  selector: 'app-layout-footer',
  templateUrl: './layout-footer.component.html',
  styleUrls: ['./layout-footer.component.scss'],
  standalone: false
})
export class LayoutFooterComponent {
  @HostBinding('class.layout-footer') readonly binding = true;
}
